import React from 'react';
import BusinessHeaderBare from "../parts/BusinessHeaderBare";
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";
import {metaDescriptions, metaTitles, title} from "../website-utils/meta";
import {Helmet} from "react-helmet";
import BusinessPasswordResetForm from "../parts/BusinessPasswordResetForm";
import fetch from 'cross-fetch';
import config from "../config";


class BusinessPasswordResetPage extends React.Component {
  resetPassword = (values, {setSubmitting, setErrors, setStatus}) => {
    const uid = this.props.match.params.uid;
    const token = this.props.match.params.token;
    setSubmitting(true);
    fetch(config.apiRoot + '/rest-auth/password/reset/confirm/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        uid: uid,
        token: token,
        new_password1: values.password1,
        new_password2: values.password2,
      }),
    }).then(
      response => {
        setSubmitting(false);

        response.json().then(body => {
          console.log(body);
        });

        if (response.status === 200) {
          setStatus("success");
        }

        if (response.status === 400) {
          setStatus("invalid");
        }
      },
      error => {
        setSubmitting(false);
        console.error(error);
      }
    )
  };

  render() {
    return (
      <div className={'business login'}>
        <Helmet>
          {title('SingleShift - Business Password Reset')}
          {metaTitles('SingleShift - Business Password Reset')}
          {metaDescriptions('Password Reset Page')}
        </Helmet>
        <ScrollToTopOnMount/>
        <div className="container">
          <BusinessHeaderBare/>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-6">
              <h2>Reset Password</h2>
            </div>
          </div>
          <div className="singleshift-form">
            <BusinessPasswordResetForm resetPassword={this.resetPassword}/>
          </div>
        </div>
      </div>
    )
  }
}


export default BusinessPasswordResetPage;




// WEBPACK FOOTER //
// ./src/pages/BusinessPasswordResetPage.js